import { useTranslation } from 'react-i18next'
import styles from 'pages/app/account-selection/AccountSelection.module.scss'
import { useStoreSelector } from 'hooks/store'
import { Banner, Heading } from '@boltenergy-be/design-system'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import AccountCard from 'pages/app/account-selection/account-card/AccountCard.tsx'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import { UserTypes } from 'store/auth/types.ts'
import LanguageSwitchButton from 'components/language-switch-button/LanguageSwitchButton.tsx'
import { isInActiveAddress } from 'utils/contracts.ts'

const AccountSelection = () => {
  // REDUX STORE
  const { contact, accounts, loading, ignoredBillingContracts, billingContracts } = useStoreSelector((store) => store.contact)
  const { userType } = useStoreSelector((store) => store.auth)

  // i18n
  const { t } = useTranslation('home')

  return (
    <PageLayout
      title={
        <div className={styles['title-wrapper']}>
          <Heading as="h1" variant="h3" className={styles.title}>
            {t(($) => $.accountSelection.hey)}{' '}
            {contact?.firstName || (
              <LoadingSkeleton>
                <LoadingSkeleton.Rectangle width={220} height={32} />
              </LoadingSkeleton>
            )}
          </Heading>

          <LanguageSwitchButton />
        </div>
      }
      seoTitle={t(($) => $.accountSelection.seoTitle)}
      description={t(($) => $.accountSelection.description)}
      classes={{ body: styles.body, header: styles.header }}
    >
      <ul className={styles['accounts-list']}>
        {loading ? (
          <LoadingSkeleton as="li" className={styles['account-loading-card']}>
            <LoadingSkeleton.Rectangle width="100%" height={120} />
          </LoadingSkeleton>
        ) : (
          Object.values(accounts)
            .sort((a, b) => {
              const aHasActiveAddress = a.billingContracts.some((c) => billingContracts[c] && !isInActiveAddress(billingContracts[c]))
              const bHasActiveAddress = b.billingContracts.some((c) => billingContracts[c] && !isInActiveAddress(billingContracts[c]))

              if (aHasActiveAddress && !bHasActiveAddress) return -1
              if (!aHasActiveAddress && bHasActiveAddress) return 1

              return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
            })
            .map((account) => <AccountCard account={account} key={account.customerNumber} />)
        )}
      </ul>

      {ignoredBillingContracts.length > 0 && userType === UserTypes.SUPER_USER && (
        <Banner type="warning" title="The following addresses are hidden for the customer:" className="mt-500">
          <ul>
            {ignoredBillingContracts.map((contractId) => (
              <li key={contractId}>{contractId} - Gas only contract</li>
            ))}
          </ul>
        </Banner>
      )}
    </PageLayout>
  )
}

export default AccountSelection
